import request from "./request";
// 汇总报表-收入报表
// 获取产品信息接口
export const getIncomeGetPros = () => request("/pro/incomeGetPros", null, "GET");
// 获取产品版本接口
export const getIncomeGetVersion = (param) => request("/pro/incomeGetVersion", param, "GET");
// 获取产品原始渠道接口
export const getIncomeGetOriChnl = (param) => request("/pro/incomeGetOriChnl", param, "GET");
// 获取产品渠道接口
export const getIncomeGetChnl = (param) => request("/pro/incomeGetChnl", param, "GET");
// 获取全部国家接口
export const getGetAllCountry = () => request("/pro/incomeGetAllCountry", null, "GET");
// 获取全部表格数据接口
export const getIncomeGetTableData = (param) => request("/pro/incomeGetTableData", param, "GET");
// 获取全部图表数据接口
export const getIncomeGetChartData = (param) => request("/pro/incomeGetChartData", param, "GET");
